module.exports = __webpack_public_path__ + "img/02-Eisai-ความรู้.9ae34f1e.png";